// Toggle navigation header (navicon)
const toggleNavigation = document.querySelector('.js-navicon')
// And action!
toggleNavigation.addEventListener('click', e => {
  e.preventDefault()
  document.querySelector('.m-navigation-header').classList.toggle('visible')
  document.querySelector('.o-header .js-navicon span').classList.toggle('active')
})
// Hide navigation on scroll
window.addEventListener('scroll', _ => {
  document.querySelector('.m-navigation-header').classList.remove('visible')
  document.querySelector('.o-header .js-navicon span').classList.remove('active')
})

// Sticky header
const stickyHeader = document.querySelector('.o-header')
// Add class sticky if scrollAmount is reached
window.addEventListener('scroll', _ => {
  let scrollAmount = 10 // Delay animation
  if (window.pageYOffset > scrollAmount) {
    stickyHeader.classList.add('sticky')
  } else {
    stickyHeader.classList.remove('sticky')
  }
})

// Highlight Navigation
const navigationHeaderHref = document.querySelectorAll('.m-navigation-header ul li a')
// Add cuurent state
navigationHeaderHref.forEach(link => {
  link.addEventListener('click', _ => {
    navigationHeaderHref.forEach(link => link.parentNode.classList.remove('current'))
    link.parentNode.classList.add('current')
  })
})
// Remove on hover another navigation entry
navigationHeaderHref.forEach(link => {
  link.addEventListener('mouseover', _ => {
    navigationHeaderHref.forEach(link => link.parentNode.classList.remove('current'))
    link.parentNode.classList.add('current')
  })
})
// Remove on scroll
window.addEventListener('scroll', _ => {
  let scrollTimer = setTimeout( _ => {
    navigationHeaderHref.forEach(link => link.parentNode.classList.remove('current'))
  }, 5000)
})

// Smooth scolling for Safari - needs smoothscroll-polyfill
// Be aware that html scroll-behavior: smooth; is set in /scss/nuclide/_reset.scss
const scrollToHash = document.querySelectorAll('a[href^="/#"]:not(a[href^="/#impressum"]):not(a[href^="/#datenschutz"]):not(a[href^="/#agb"])') // In our case we have to query for "/#"
// This is done because 11ty navigation only accepts entries prepended with a slash
// Also we exclude #impressum + #datenschutz and #agb because we use them for opening a layer @see: /molecule/navigation-footer.js
// console.log(scrollToHash)
scrollToHash.forEach(hash => { // Loop through query to get all hashes
  // console.log(hash.href.split('/')[3]) // Figure out only the hash value
  // Filter hash
  let hashOnly = hash.href.split('/')[3]
  // console.log(hashOnly) // Show all found hashes
  hash.addEventListener('click', _ => {
    document.querySelector(hashOnly).scrollIntoView({
      behavior: 'smooth'
    })
  })
})
